import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import messages from '../messages';
import { Button } from '@altify/components';
import { setToken } from 'utils/token';
import useLogout from 'hooks/useLogout';

export const Route = createFileRoute('/auth/reset-two-factor/_/submitted')({
  component: ResetTwoFactorResponseView,
});

export default function ResetTwoFactorResponseView() {
  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );
  const navigate = useNavigate();
  const logout = useLogout();
  const resetTwoFactorResponseMessages =
    messages[language].resetTwoFactorResponse;

  return (
    <div className="flex flex-col bg-ghost-white py-6">
      <div className="sm:max-w-xl sm:mx-auto sm:w-full">
        <h2 className="font-semibold leading-9 text-2.5x1 text-black text-center tracking-wide">
          {resetTwoFactorResponseMessages.heading}
        </h2>
      </div>

      <div className="sm:max-w-xs sm:mx-auto sm:w-full text-center">
        <div className="m-6">
          <p>{resetTwoFactorResponseMessages.firstParagraph}</p>
          <p className="mt-6">
            {resetTwoFactorResponseMessages.secondParagraph}
          </p>
        </div>

        <div className="mt-8 sm:max-w-xs sm:mx-auto sm:w-full text-center">
          <span className="block w-full rounded-md">
            <Button
              onPress={logout}
              className="px-2 py-2"
              text={resetTwoFactorResponseMessages.backToRevixButton}
            />
          </span>
        </div>
      </div>
    </div>
  );
}
